import { CommonPropertyProps } from "schemas/elements";
import { IdData } from "hooks/FormDesigner/useElementList";
import IdSelect from "./IdSelect";
import Text from "../Text";
import { SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps | undefined;
	idList: IdData;
	disabledPlaceholder?: string;
	entityUri?: SearchSelectOptionProps;
	isSearchView?: boolean;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	idList,
	nestedField,
	disabledPlaceholder,
	entityUri,
	isSearchView,
	id,
	isEmu,
}: Props) => {
	const props = {
		updateStore,
		field,
		required,
		desc,
		validation,
		elementIndex,
		isEmu,
		nestedField,
	};

	if (nestedField === "search" || (idList !== undefined && idList.length > 0))
		return (
			<IdSelect
				{...props}
				idList={idList}
				disabledPlaceholder={disabledPlaceholder}
				entityUri={entityUri}
				isSearchView={isSearchView}
				value={
					value !== undefined
						? typeof value === "string"
							? { value: value, label: value }
							: value
						: value
				}
			/>
		);
	else
		return (
			<Text
				{...props}
				id={id}
				value={
					value !== undefined
						? typeof value === "string"
							? value
							: value.value
						: value
				}
			/>
		);
};
